import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { isValid } from "date-fns";

import DatePicker from "react-datepicker";

import "./DateTimePicker.scss";

import "react-datepicker/dist/react-datepicker.css";

const DateTimePicker = ({
  name,
  value: initialValue,
  onChange = console.log,
  required,
  disabled
}) => {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (initialValue) {
      const date = new Date(initialValue);
      if (isValid(date)) {
        setSelected(date);
      }
    }
  }, [initialValue]);

  const handleChange = date => {
    setSelected(date);
  };

  const handleOutsideClick = () => {
    onChange({
      target: {
        name,
        value: selected,
        type: "datetime-local"
      }
    });
  };
  const classList = ["input"].join(" ");
  return (
    <DatePicker
      showTimeSelect
      autoComplete="off"
      className={classList}
      dateFormat="MM/dd/yyyy HH:mm"
      disabled={disabled}
      name={name}
      required={required}
      selected={selected}
      shouldCloseOnSelect={false}
      timeCaption="Time"
      timeFormat="HH:mm"
      timeIntervals={15}
      onChange={handleChange}
      onClickOutside={handleOutsideClick}
    />
  );
};

DateTimePicker.propTypes = {
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string
};
export default DateTimePicker;
